import { authMiddleware } from '@/router/middleware/authMiddleware'
import { roleMiddleware } from '@/router/middleware/roleMiddleware'
import AdminMenuConfig from '@/config/AdminMenuConfig'
import RolesHelper from '@/helpers/Roles'

const admin = [
    {
        path: '/admin',
        component: () => import('@/components/Layout/AdminLayout.vue'),
        props: {
            menu: AdminMenuConfig,
        },
        // beforeEnter: [authMiddleware, roleMiddleware],
        // meta: {
        //     authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
        // },
        children: [
            {
                path: 'dashboard',
                name: 'admin-dashboard',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                component: () => import('@/views/Admin/Dashboard.vue'),
            },
            {
                path: 'me',
                name: 'admin-profile',
                component: () => import('@/views/Admin/Profile.vue'),
            },
            {
                path: 'user',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                children: [
                    {
                        path: '',
                        name: 'admin-user',
                        component: () => import('@/views/Admin/User.vue'),
                    },
                    {
                        path: 'add',
                        name: 'admin-user-add',
                        component: () => import('@/views/Admin/Components/Forms/User.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'admin-user-edit',
                        component: () => import('@/views/Admin/Components/Forms/User.vue'),
                    },
                ],
            },
            {
                path: 'prelander',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                children: [
                    {
                        path: '',
                        name: 'admin-prelander',
                        component: () => import('@/views/Admin/Prelander.vue'),
                    },
                    {
                        path: 'add',
                        name: 'admin-prelander-add',
                        component: () => import('@/views/Admin/Components/Forms/Prelander.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'admin-prelander-edit',
                        component: () => import('@/views/Admin/Components/Forms/Prelander.vue'),
                    },
                ],
            },
            {
                path: 'offer',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                children: [
                    {
                        path: '',
                        name: 'admin-offer',
                        component: () => import('@/views/Admin/Offer.vue'),
                    },
                    {
                        path: 'add',
                        name: 'admin-offer-add',
                        component: () => import('@/views/Admin/Components/Forms/Offer.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'admin-offer-edit',
                        component: () => import('@/views/Admin/Components/Forms/Offer.vue'),
                    },
                ],
            },
            {
                path: 'order',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                children: [
                    {
                        path: '',
                        name: 'admin-order',
                        component: () => import('@/views/Admin/Order.vue'),
                    },
                    {
                        path: 'add',
                        name: 'admin-order-add',
                        component: () => import('@/views/Admin/Components/Forms/Order.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'admin-order-edit',
                        component: () => import('@/views/Admin/Components/Forms/Order.vue'),
                    },
                ],
            },
            {
                path: 'smart-cpa',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                children: [
                    {
                        path: '',
                        name: 'admin-smartcpa',
                        component: () => import('@/views/Admin/SmartCpa.vue'),
                    },
                    {
                        path: 'add',
                        name: 'admin-smartcpa-add',
                        component: () => import('@/views/Admin/Components/Forms/SmartCpa.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'admin-smartcpa-edit',
                        component: () => import('@/views/Admin/Components/Forms/SmartCpa.vue'),
                    },
                ],
            },
            {
                path: 'advertiser',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                children: [
                    {
                        path: '',
                        name: 'admin-advertiser',
                        component: () => import('@/views/Admin/Advertiser.vue'),
                    },
                    {
                        path: 'add',
                        name: 'admin-advertiser-add',
                        component: () => import('@/views/Admin/Components/Forms/Advertiser.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'admin-advertiser-edit',
                        component: () => import('@/views/Admin/Components/Forms/Advertiser.vue'),
                    },
                ],
            },
            {
                path: 'publisher',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                children: [
                    {
                        path: '',
                        name: 'admin-publisher',
                        component: () => import('@/views/Admin/Publisher.vue'),
                    },
                    {
                        path: 'add',
                        name: 'admin-publisher-add',
                        component: () => import('@/views/Admin/Components/Forms/Publisher.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'admin-publisher-edit',
                        component: () => import('@/views/Admin/Components/Forms/Publisher.vue'),
                    },
                ],
            },
            {
                path: 'affiliate',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                children: [
                    {
                        path: '',
                        name: 'admin-affiliate',
                        component: () => import('@/views/Admin/Affiliate.vue'),
                    },
                    {
                        path: 'add',
                        name: 'admin-affiliate-add',
                        component: () => import('@/views/Admin/Components/Forms/Affiliate.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'admin-affiliate-edit',
                        component: () => import('@/views/Admin/Components/Forms/Affiliate.vue'),
                    },
                ],
            },
            {
                path: 'categories',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                children: [
                    {
                        path: '',
                        name: 'admin-category',
                        component: () => import('@/views/Admin/Category.vue'),
                    },
                    {
                        path: 'add',
                        name: 'admin-category-add',
                        component: () => import('@/views/Admin/Components/Forms/Category.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'admin-category-edit',
                        component: () => import('@/views/Admin/Components/Forms/Category.vue'),
                    },
                ],
            },
            {
                path: 'campaign',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Publisher, RolesHelper.Roles.Advertiser],
                },
                children: [
                    {
                        path: '',
                        name: 'admin-campaign',
                        component: () => import('@/views/Admin/Campaign.vue'),
                    },
                    {
                        path: 'add',
                        name: 'admin-campaign-add',
                        component: () => import('@/views/Admin/Components/Forms/Campaign.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'admin-campaign-edit',
                        component: () => import('@/views/Admin/Components/Forms/Campaign.vue'),
                    },
                ],
            },
            {
                path: 'lead',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                children: [
                    {
                        path: '',
                        name: 'admin-lead',
                        component: () => import('@/views/Admin/Lead.vue'),
                    },
                    {
                        path: 'add',
                        name: 'admin-lead-add',
                        component: () => import('@/views/Admin/Components/Forms/Lead.vue'),
                    },
                    {
                        path: 'edit/:id',
                        name: 'admin-lead-edit',
                        component: () => import('@/views/Admin/Components/Forms/Lead.vue'),
                    },
                ],
            },
            {
                path: 'stat',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                name: 'admin-stat',
                component: () => import('@/views/Admin/Stat.vue'),
            },
            {
                path: 'stat-v2',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                name: 'admin-stat-v2',
                component: () => import('@/views/Admin/StatV2.vue'),
            },
            {
                path: 'stat-live',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                name: 'admin-stat-live',
                component: () => import('@/views/Admin/StatLive.vue'),
            },
            {
                path: 'stat-delivery',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                name: 'admin-stat-delivery',
                component: () => import('@/views/Admin/StatDelivery.vue'),
            },
            {
                path: 'settings',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                children: [
                    {
                        path: 'site',
                        name: 'admin-settings-site',
                        component: () => import('@/views/Admin/Components/Settings/Site.vue'),
                    },
                    {
                        path: 'filter',
                        name: 'admin-settings-filter',
                        component: () => import('@/views/Admin/Components/Settings/Filter.vue'),
                    },
                    {
                        path: 'parameters',
                        name: 'admin-settings-parameters',
                        component: () => import('@/views/Admin/Components/Settings/Parameters.vue'),
                    },
                    {
                        path: 'migration-issues',
                        name: 'admin-settings-migration-issues',
                        beforeEnter: [roleMiddleware],
                        meta: {
                            authorize: [RolesHelper.Roles.Admin],
                        },
                        component: () => import('@/views/Admin/Components/Settings/MigrationIssues.vue'),
                    },
                    {
                        path: 'api-endpoints',
                        children: [
                            {
                                path: '',
                                name: 'admin-settings-api-endpoints',
                                component: () => import('@/views/Admin/Components/Settings/ApiEndpoints.vue'),
                            },
                            {
                                path: 'add',
                                name: 'admin-settings-api-endpoints-add',
                                component: () => import('@/views/Admin/Components/Forms/Settings/ApiEndpoints.vue'),
                            },
                            {
                                path: 'edit/:id',
                                name: 'admin-settings-api-endpoints-edit',
                                component: () => import('@/views/Admin/Components/Forms/Settings/ApiEndpoints.vue'),
                            },
                        ],
                    },
                    {
                        path: 'connector',
                        children: [
                            {
                                path: '',
                                name: 'admin-settings-connector',
                                component: () => import('@/views/Admin/Components/Settings/Connector.vue'),
                            },
                            {
                                path: 'add',
                                name: 'admin-settings-connector-add',
                                component: () => import('@/views/Admin/Components/Forms/Connector.vue'),
                            },
                            {
                                path: 'add-old',
                                name: 'admin-settings-connector-add-old',
                                component: () => import('@/views/Admin/Components/Forms/Connector_old.vue'),
                            },
                            {
                                path: 'edit/:id',
                                name: 'admin-settings-connector-edit',
                                component: () => import('@/views/Admin/Components/Forms/Connector.vue'),
                            },
                        ],
                    },
                    {
                        path: 'commission',
                        beforeEnter: [roleMiddleware],
                        meta: {
                            // authorize: [RolesHelper.Roles.Admin],
                        },
                        children: [
                            {
                                path: 'plans',
                                name: 'admin-commission-plans',
                                component: () => import('@/views/Admin/Commission/CommissionPlans.vue'),
                            },
                            {
                                path: 'events',
                                name: 'admin-commission-events',
                                component: () => import('@/views/Admin/Commission/CommissionEvents.vue'),
                            },
                            {
                                path: 'devalidations',
                                name: 'admin-commission-devalidations',
                                component: () => import('@/views/Admin/Commission/DevalidationImport.vue'),
                            },
                        ],
                    },
                ]
            },
            {
                path: 'demand',
                beforeEnter: [roleMiddleware],
                meta: {
                    authorize: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
                },
                name: 'admin-demand',
                component: () => import('@/views/Admin/Demand.vue'),
            },
        ],
    },
]

export default admin
